export const getBoxValue = object => Object.values(object).join(" ");